import { Outlet } from 'react-router';

import { ID_PARAMS, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import OrganizationGroupsForm from 'portal/src/components/systemAdministration/Form/OrganizationGroupsForm';
import OrganizationGroups from 'portal/src/components/systemAdministration/OrganizationGroups';
import Organizations from 'portal/src/components/systemAdministration/Organizations';
import BaseForm from 'portal/src/layouts/base/BaseForm';
import SystemAdministrationOrganizationForm from 'portal/src/pages/systemAdministration/SystemAdministrationOrganizationForm';
import SystemAdministrationOrgUserForm from 'portal/src/pages/systemAdministration/SystemAdministrationOrgUserForm';
import SystemAdministrationUserForm from 'portal/src/pages/systemAdministration/SystemAdministrationUserForm';
import SystemAdministrationUsers from 'portal/src/pages/systemAdministration/SystemAdministrationUsers';

import { RouteDefinition } from './routeGenerator';

export const systemAdministrationRouteDefinitions: RouteDefinition[] = [
  {
    element: <Outlet />,
    children: [
      {
        element: <Organizations />,
        index: true,
      },
      {
        element: <Outlet />,
        path: ID_PARAMS.ORG,
        children: [
          {
            element: (
              <BaseForm
                apiPath={API_BASE_PATHS.ORGANIZATIONS}
                Component={SystemAdministrationOrganizationForm}
                idParamName={ID_PARAMS.ORG}
                allowAllOrgs
              />
            ),
            index: true,
          },
          {
            element: (
              <BaseForm
                apiPath={API_BASE_PATHS.USERS}
                Component={SystemAdministrationOrgUserForm}
                idParamName={ID_PARAMS.USER}
                allowAllOrgs
              />
            ),
            path: NESTED_ROUTES.SYSTEM_ADMINISTRATION.ORG_USERS,
          },
        ],
      },
    ],
    path: NESTED_ROUTES.SYSTEM_ADMINISTRATION.ORGANIZATIONS,
    name: 'Organizations',
  },
  {
    element: <Outlet />,
    children: [
      {
        element: (
          <BaseForm
            apiPath={API_BASE_PATHS.ORGANIZATION_GROUPS}
            Component={OrganizationGroupsForm}
            allowAllOrgs
          />
        ),
        path: ID_PARAMS.ANY,
      },
      {
        element: <OrganizationGroups />,
        index: true,
      },
    ],
    path: NESTED_ROUTES.SYSTEM_ADMINISTRATION.ORGANIZATION_GROUPS,
    name: 'Organization Groups',
  },
  {
    element: <Outlet />,
    children: [
      {
        element: (
          <BaseForm
            apiPath={API_BASE_PATHS.USERS}
            Component={SystemAdministrationUserForm}
            allowAllOrgs
          />
        ),
        path: ID_PARAMS.ANY,
      },
      {
        element: <SystemAdministrationUsers />,
        index: true,
      },
    ],
    path: NESTED_ROUTES.SYSTEM_ADMINISTRATION.USERS,
    name: 'Users',
  },
];
